import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 120,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.hashid}</p>`
        },
    },
    {
        field: 'full_name',
        title: i18n.t('label.name'),
        sortable: true,
        width: 120,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.full_name}</p>`
        },
    },
    {
        field: 'subset_profit_percent',
        title: i18n.t('marketing.dashboard.referer_percent') + ' ' + '(' + i18n.t('marketing.dashboard.percentage') + ')',
        sortable: true,
        width: 150,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.subset_profit_percent}</p>`
        },
    },
    {
        field: 'created_at',
        title: i18n.t('label.register_date'),
        sortable: true,
        width: 120,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.created_at}</p>`
        },
    },
    {
        field: 'subset_profit_amount',
        title: i18n.t('label.subset_benefit') + ' ' + '(' + i18n.t('currency.rial') + ')',
        sortable: true,
        width: 130,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.subset_profit_amount}</p>`
        },
    },
]